"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.skeletonAnimation = exports.glow = void 0;
const styled_components_1 = require("styled-components");
exports.glow = (0, styled_components_1.keyframes) `
  0%,
  100% {
    opacity: 1;
  }
  
  50% {
    opacity: 0.4;
  }
`;
exports.skeletonAnimation = (0, styled_components_1.css) `
  color: transparent;

  animation: ${exports.glow} 1.5s ease-in-out infinite;
  cursor: progress;
`;
